<img [ngClass]="{animate, 'animate-on-hover': animateOnHover}"
      [src]="getSrc()"
      alt="Epson Rewards logo">
